import { render, staticRenderFns } from "./ziliao.vue?vue&type=template&id=9fb1a3cc&scoped=true&"
import script from "./ziliao.vue?vue&type=script&lang=ts&"
export * from "./ziliao.vue?vue&type=script&lang=ts&"
import style0 from "./ziliao.vue?vue&type=style&index=0&id=9fb1a3cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb1a3cc",
  null
  
)

export default component.exports